const REDIRECT_KEY = 'post_login_redirect';

export function setPostLoginRedirect(href) {
  if (typeof window === 'undefined') return;
  if (!href || typeof href !== 'string') return;
  try {
    window.localStorage.setItem(REDIRECT_KEY, href);
  } catch {
    // Ignore storage errors (private mode, blocked storage).
  }
}

export function consumePostLoginRedirect() {
  if (typeof window === 'undefined') return null;
  try {
    const href = window.localStorage.getItem(REDIRECT_KEY);
    if (href) window.localStorage.removeItem(REDIRECT_KEY);
    return href;
  } catch {
    return null;
  }
}
